import { render, staticRenderFns } from "./SidebarQuickSearch.vue?vue&type=template&id=2ce8df88&scoped=true"
import script from "./SidebarQuickSearch.vue?vue&type=script&lang=js"
export * from "./SidebarQuickSearch.vue?vue&type=script&lang=js"
import style0 from "./SidebarQuickSearch.vue?vue&type=style&index=0&id=2ce8df88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce8df88",
  null
  
)

export default component.exports